import React from 'react'
import { connect } from 'react-redux'
import { v4 as uuidv4 } from 'uuid'
import { useTranslation } from 'react-i18next'
import { AppState, RootState, Dispatcher, DashboardState } from 'AppTypes'

type Props = {
  appState: AppState
  dashboardState: DashboardState
  dispatch: Dispatcher
}

const VideoViewsOverallRanking: React.FC<Props> = ({
  dashboardState: {
    storeStatistic
  }
}) => {
  const { t } = useTranslation()
  return (
    <div className="row mt-4">
      <div className="col-12">
        <h2>
          <i className="fas fa-crown" />
          <span>{t('dashboard.numberOfVideoViews')}</span>{t('dashboard.overallRanking')}
        </h2>
      </div>
      {
        !(storeStatistic.overallVideoRanking || []).length
          ? <div className="col-12">{t('states.noData')}</div>
          : storeStatistic.overallVideoRanking.map((video, index) => (
            <div key={uuidv4()} className="col-4 item-top-views">
              <div className="number-views">{index + 1}</div>
              <img src="/assets/img/image-placeholder.png" alt="" />
            </div>
          ))
      }
    </div>
  )
}

export default connect((state: RootState) => ({
  appState: state.app,
  dashboardState: state.dashboard
}))(VideoViewsOverallRanking)
